import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cus-userpolicy',
  templateUrl: './userpolicy.component.html',
  styleUrls: ['./userpolicy.component.scss']
})
export class UserpolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
